module.exports = __webpack_public_path__ + "img/1aa3e3451b96d7f5eab8fff8e107adb7.1aa3e345.png";